import { render, staticRenderFns } from "./showText-editor.vue?vue&type=template&id=30a6ba9e&scoped=true"
import script from "./showText-editor.vue?vue&type=script&lang=js"
export * from "./showText-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a6ba9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30a6ba9e')) {
      api.createRecord('30a6ba9e', component.options)
    } else {
      api.reload('30a6ba9e', component.options)
    }
    module.hot.accept("./showText-editor.vue?vue&type=template&id=30a6ba9e&scoped=true", function () {
      api.rerender('30a6ba9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-rate/showText-editor.vue"
export default component.exports